/**
 * Template JS - entry point.
 *
 * Bundled by `npm run build:libs` (esbuild) into assets/js/app.js
 * (+ app.min.js) - edit the modules here, never the bundle.
 *
 * Everything uses data-* attributes as "hooks", so it doesn't depend on the
 * exact HTML structure and works identically in the EJS version and the
 * exported HTML version.
 */
import { initSidebar } from './sidebar.js';
import { initTheme } from './theme.js';
import { initFullscreen } from './fullscreen.js';
import { initLanguage } from './language.js';
import { initWorkspace } from './workspace.js';
import { initSearch } from './search.js';
import { initLogout } from './logout.js';
import { initTooltip } from './tooltip.js';
import { initPassword } from './password.js';
import { initImpersonate } from './impersonate.js';
import { initNotifications } from './notifications.js';
import { initConsents } from './consents.js';

initSidebar();
initTheme();
initFullscreen();
initLanguage();
initWorkspace();
initSearch();
initLogout();
initTooltip();
initPassword();
initImpersonate();
initNotifications();
initConsents();
